
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import AdminDashboard from '@/components/admin/AdminDashboard';

const Dashboard = () => {
  const { user, profile } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  if (!user || !profile || !['admin', 'superadmin'].includes(profile.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">
            {t('access_denied', 'غير مسموح بالوصول', 'Access Denied')}
          </h1>
          <p className="text-muted-foreground mb-4">
            {t('admin_only', 'هذه الصفحة متاحة للمدراء فقط', "You don't have permission to access this page.")}
          </p>
          <Button onClick={() => navigate('/')}>
            {t('go_to_homepage', 'الذهاب للصفحة الرئيسية', 'Go to Homepage')}
          </Button>
        </div>
      </div>
    );
  }

  return <AdminDashboard />;
};

export default Dashboard;
